<template>
  <div>
    <h1 class="text-xl pb-4 pl-2 font-extrabold tracking-tight text-gray-900">
      {{ $t("Documents") }}
    </h1>
    <ul role="list" class="divide-y divide-gray-100">
      <li v-if="plan.formulaChangeLetter" class="py-2 hover:bg-gray-200 cursor-pointer">
        <div class="flex gap-x-4" @click="openLink(plan.formulaChangeLetter)">
          <DocumentTextIcon class="h-12 w-12 flex-none rounded-full text-primary-dark" />
          <div class="min-w-0 flex-auto">
            <p class="text-sm font-semibold leading-6 text-gray-900">Courrier d'information de changement de formule</p>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              Le document relatif au changement de formule de votre contrat
            </p>
          </div>
        </div>
      </li>
      <li class="py-2 hover:bg-gray-200 cursor-pointer">
        <div class="flex gap-x-4" @click="openLink(plan.informationNotice)">
          <DocumentTextIcon class="h-12 w-12 flex-none rounded-full text-primary-dark" />
          <div class="min-w-0 flex-auto">
            <p class="text-sm font-semibold leading-6 text-gray-900">Notice d’information</p>
            <p class="mt-1 text-sm leading-5 text-gray-500">Un document utile détaillant l’ensemble de vos garanties</p>
          </div>
        </div>
      </li>
      <li v-if="isInsurancePlan" class="py-2 hover:bg-gray-200 cursor-pointer">
        <div class="flex gap-x-4" @click="openLink(plan.ipidFile)">
          <DocumentTextIcon class="h-12 w-12 flex-none rounded-full text-primary-dark" />
          <div class="min-w-0 flex-auto">
            <p class="text-sm font-semibold leading-6 text-gray-900">Fiche d’information produit</p>
            <p class="mt-1 text-sm leading-5 text-gray-500">Le contenu de votre contrat</p>
          </div>
        </div>
      </li>
      <li v-if="plan.sepaPayment" class="py-2 hover:bg-gray-200 cursor-pointer">
        <div data-test="sepa-mandate" class="flex gap-x-4" @click="downloadSepaMandate">
          <DocumentTextIcon class="h-12 w-12 flex-none rounded-full text-primary-dark" />
          <div class="min-w-0 flex-auto">
            <p class="text-sm font-semibold leading-6 text-gray-900">{{ t("sepa_mandate_title") }}</p>
            <p class="mt-1 text-sm leading-5 text-gray-500">{{ t("sepa_mandate_description") }}</p>
          </div>
        </div>
      </li>
      <li class="py-2 hover:bg-gray-200 cursor-pointer">
        <div class="flex gap-x-4" @click="downloadMembershipAgreement">
          <DocumentTextIcon class="h-12 w-12 flex-none rounded-full text-primary-dark" />
          <div class="min-w-0 flex-auto">
            <p class="text-sm font-semibold leading-6 text-gray-900">Certificat d’adhésion</p>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              Le document attestant de votre couverture auprès d’Estaly
            </p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { DocumentTextIcon } from "@heroicons/vue/solid";
import { mapGetters } from "vuex";
import { useI18n } from "vue-i18n";
import PlanSalesService from "@/api/services/planSales";

export default {
  props: ["plan"],

  components: {
    DocumentTextIcon,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    ...mapGetters("plan", ["insurancePlan"]),

    isInsurancePlan() {
      return this.insurancePlan(this.plan);
    },
  },

  methods: {
    async downloadMembershipAgreement() {
      await PlanSalesService.getPlanMembershipAgreement(this.plan.friendlyId)
        .then((response) => {
          const url = response.data.file_url;
          this.openLink(url);
        })
        .catch((error) => {
          // Handle any errors
          console.error(error);
        });
    },

    async downloadSepaMandate() {
      await PlanSalesService.getPlanSepaMandate(this.plan.friendlyId)
        .then((response) => {
          const url = response.data.file_url;
          this.openLink(url);
        })
        .catch((error) => {
          // Handle any errors
          console.error(error);
        });
    },

    openLink(link) {
      window.open(link, "_blank", "noopener,noreferrer");
    },
  },
};
</script>

<i18n src="./PlanSaleDocuments.i18n.json"></i18n>
